/**
 * Shared Enums and Types
 * Centralized location for all business logic enums used across the application
 */

// Measurement and electrical types
export type MetingStatus = 'voldoet' | 'voldoetNiet' | 'neutraal' | 'nvt'
export type StroomStelsel = "TN-C-S" | "TN-C" | "TN-S" | "TT" | "IT"
export type TypeBeveiliging = 'Smeltpatroon' | 'Automaat'
export type TypeAls = 'A' | 'AC' | 'B'
export type TypeAansluiting = '1P+N' | '1P' | '3P+N' | '3P'
export type TypeOnderdeel = 'Groep' | 'Aardlekautomaat' | 'Aardlekschakelaar'
export type TypeSmeltpatroon = 'gG' | 'gF' | 'gL'
export type TypeAutomaat = 'B' | 'C' | 'D'
export type MetingTussen = 'L-N' | 'L-PE' | 'N-PE' |'L1-L2' | 'L1-L3' | 'L2-L3' | 'L1-N' | 'L2-N' | 'L3-N' | 'L1-PE' | 'L2-PE' | 'L3-PE'
export type TypeMateriaal = 'verdeler' | 'onderdeel' | 'omvormer'

// Status and workflow types
export type RapportStatus = 'nieuw' | 'bezig' | 'voldoet' | 'voldoet_niet' | 'hersteld' | 'verlopen' | 'ingetrokken'
export type RapportHerinspectieStatus = 'ingepland' | 'bezig' | 'voldoet' | 'voldoet_niet'
export type PlanningEventType = 'inspectie' | 'herinspectie' | 'afspraak' | 'blokkade' | 'vakantie' | 'beschikbaar'
export type PlanningEventStatus = 'gepland' | 'afgerond' | 'geannuleerd'
export type OfferteStatus = 'nieuw' | 'aangepast' | 'verzonden' | 'bekeken' | 'deels_geaccepteerd' | 'alles_geaccepteerd' | 'foute_inzending' | 'ingepland' | 'afgewezen' | 'ingetrokken' | 'gefactureerd'

// Inspection and product types
export type InspectieType = 'scope8pi' | 'scope8ebi' | 'scope10' | 'scope12pi' | 'scope12ebi' | 'nen1010' | 'nen3140'
export type PrintType = InspectieType | 'rapport' | 'offerte' | 'factuur'
export type ProductType = InspectieType | 'km' | 'overige' | 'scope8' | 'scope12'
export type FreqBasis = 'Verzekering' | 'NTA8220' | 'NEN3140' | 'TD18' | 'Anders...' | 'Huurcontract'
export type PrijsType = 'voorgesteld' | 'aangepast'

// Assessment and findings
export type BeoordelingType = 'opmerking' | 'gering' | 'serieus' | 'ernstig'

// Values arrays for generating options
export const metingStatusValues: MetingStatus[] = ['voldoet', 'voldoetNiet', 'neutraal', 'nvt']
export const stroomStelselValues: StroomStelsel[] = ["TN-C-S", "TN-C", "TN-S", "TT", "IT"]
export const typeBeveiligingValues: TypeBeveiliging[] = ['Smeltpatroon', 'Automaat']
export const typeAlsValues: TypeAls[] = ['A', 'AC', 'B']
export const typeAansluitingValues: TypeAansluiting[] = ['1P+N', '1P', '3P+N', '3P']
export const typeOnderdeelValues: TypeOnderdeel[] = ['Groep', 'Aardlekautomaat', 'Aardlekschakelaar']
export const typeSmeltpatroonValues: TypeSmeltpatroon[] = ['gG', 'gF', 'gL']
export const typeAutomaatValues: TypeAutomaat[] = ['B', 'C', 'D']
export const metingTussenValues: MetingTussen[] = ['L-N', 'L-PE', 'N-PE', 'L1-L2', 'L1-L3', 'L2-L3', 'L1-N', 'L2-N', 'L3-N', 'L1-PE', 'L2-PE', 'L3-PE']
export const typeMateriaalValues: TypeMateriaal[] = ['verdeler', 'onderdeel', 'omvormer']
export const rapportStatusValues: RapportStatus[] = ['nieuw', 'bezig', 'voldoet', 'voldoet_niet', 'hersteld', 'verlopen', 'ingetrokken']
export const rapportHerinspectieStatusValues: RapportHerinspectieStatus[] = ['ingepland', 'bezig', 'voldoet', 'voldoet_niet']
export const offerteStatusValues: OfferteStatus[] = ['nieuw', 'aangepast', 'verzonden', 'bekeken', 'deels_geaccepteerd', 'alles_geaccepteerd', 'foute_inzending', 'ingepland', 'afgewezen', 'ingetrokken', 'gefactureerd']
export const inspectieTypeValues: InspectieType[] = ['scope8pi', 'scope8ebi', 'scope10', 'scope12pi', 'scope12ebi', 'nen1010', 'nen3140']
export const productTypeValues: ProductType[] = ['scope8pi', 'scope8ebi', 'scope10', 'scope12pi', 'scope12ebi', 'nen1010', 'nen3140', 'km', 'overige', 'scope8', 'scope12']
export const freqBasisValues: FreqBasis[] = ['Verzekering', 'NTA8220', 'NEN3140', 'TD18']
export const prijsTypeValues: PrijsType[] = ['voorgesteld', 'aangepast']
export const beoordelingTypeValues: BeoordelingType[] = ['opmerking', 'gering', 'serieus', 'ernstig']
